import React from 'react';
import DialogActions from '@mui/material/DialogActions';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const UiDialogActions = (props) => {
  const { children, className, ...restProps } = props;
  return (
    <DialogActions
      className={classNames('ui-dialog-actions', 'card-footer', className)}
      {...restProps}
    >
      {children}
    </DialogActions>
  );
};

UiDialogActions.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default UiDialogActions;
